import React from "react";
import ClassyDonateForm from "./ClassyDonateForm";

const ClassyDonate = ({impactFields}) => {

  const impact = JSON.parse(`${impactFields}`);

  function introText() {
    const formattedIntroText = impact.intro;
    return {__html: formattedIntroText};
  }

  return (
    <div className="Card">
      <div className="Card-header Card-header--violet-dark">
        <h2 className="ClassyDonate-title c-white f-bold u-mb2">{impact.title}</h2>
        <div className="ClassyDonate-text c-white u-mb1" dangerouslySetInnerHTML={introText()}></div>
      </div>
      <div className="Card-inner bg-violet-light-50">
        <div className="Card-inner-content">
          <ClassyDonateForm impactFields={impactFields}/>
        </div>
      </div>
    </div>
  );
};

export default ClassyDonate;
